export default "__VITE_ASSET__mkTVO6eM__"